/* global isEmpty */
/* eslint-disable max-statements, complexity, no-use-before-define, max-depth, no-shadow, wrap-iife */
(function ($) {
    'use strict';

    var $savedCoursesResults = $('.saved-courses-results'),
        $savedCoursesNoResult = $('.course-search-results__no-result'),
        $savedCourseLoading = $('.course-search-results__loading'),
        $savedCoursesCounter = $('.course-search-results__counter'),
        $savedCoursesIcon = $('.course-search-results__icon'),
        $savedCoursesTitle = $('.js-course-search-results__title'),
        $findCta = $('.js-find-courses'),
        $findDownload = $('.js-download-brochure');

    if ($('[data-course-id][data-course-info]').length) {
        activateCourses(false, false);
    }

    updateCompareCounter();
    updateSavedCounter();

    if ($('.bespoke-tile').length) {
        var $bespokeTile = $('.bespoke-tile'),
            bespokeTileId = $bespokeTile.attr('data-course-id'),
            bespokeTileInfo = $bespokeTile.attr('data-course-info'),
            $bespokeTileCompare = $bespokeTile.find('.js-compare');

        if (typeof localStorage.comparedCourses !== 'undefined') {
            var comparedCourses = JSON.parse(localStorage.getItem('comparedCourses'));

            if (comparedCourses.hasOwnProperty(bespokeTileId)) {
                $bespokeTileCompare.addClass('active').attr('aria-pressed', 'true');
            } else {
                $bespokeTileCompare.removeClass('active').attr('aria-pressed', 'false');
            }
        }

        $bespokeTileCompare.click(function () {
            if ($bespokeTileCompare.hasClass('active')) {
                $bespokeTileCompare.removeClass('active').attr('aria-pressed', 'false');
                removeCourse('comparedCourses', bespokeTileId);
            } else {
                $bespokeTileCompare.addClass('active').attr('aria-pressed', 'true');
                addCourse('comparedCourses', bespokeTileId, bespokeTileInfo);
            }

            if ($('.js-compare-slider').length) {
                location.reload();
            }
        });
    }

    if ($savedCoursesResults.length) {
        var $savedCoursesTemplate = $savedCoursesResults
            .find('.panel-description--template')
            .clone()
            .removeClass('panel-description--template'),
            $savedCoursesContainer = $savedCoursesResults.find(
                '.course-search-results__list-wrapper'
            );

        if (typeof localStorage.savedCourses !== 'undefined') {
            var savedCourses = JSON.parse(localStorage.getItem('savedCourses'));

            var sortedSavedCourses = $.map(savedCourses, function (course) {
                return JSON.parse(decodeURIComponent(course));
            }).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });

            if (sortedSavedCourses.length) {
                $.each(sortedSavedCourses, function (_index, data) {
                    var courseInfo = data,
                        courseId = data.id,
                        $savedCourse = $savedCoursesTemplate.clone();

                    $savedCourse
                        .attr('data-course-id', courseId)
                        .attr('data-course-info', savedCourses[courseId])
                        .find('[data-field]')
                        .each(function () {
                            var $field = $(this),
                                fieldName = $field.attr('data-field'),
                                fieldType = $field.attr('data-field-type');

                            switch (fieldType) {
                                case 'html':
                                    $field.html(courseInfo[fieldName]);
                                    break;
                                case 'string':
                                    if (!courseInfo[fieldName]) {
                                        $field.parent('div:not([class])').remove();
                                    } else {
                                        $field.text(courseInfo[fieldName]);
                                    }
                                    break;
                                case 'link':
                                    $field.attr('href', courseInfo[fieldName]);
                                    break;
                                case 'list':
                                    var listHtml = '<ul>';
                                    $.each(courseInfo[fieldName], function (_key, listItemName) {
                                        listHtml += '<li>' + listItemName + '</li>';
                                    });
                                    listHtml += '</ul>';
                                    $field.html(listHtml);
                                    break;
                                case 'boolean':
                                    if (!courseInfo[fieldName]) {
                                        $field.hide();
                                    }
                                    break;
                            }
                        });

                    $savedCourse.find('[data-hide-if-empty]').each(function () {
                        var $el = $(this),
                            fieldName = $el.attr('data-hide-if-empty'),
                            fieldVal = courseInfo[fieldName];

                        if (isEmpty(fieldVal)) {
                            $el.remove();
                        }
                    });

                    $savedCourse.find('[data-show-if-empty]').each(function () {
                        var $el = $(this),
                            fieldName = $el.attr('data-show-if-empty'),
                            fieldVal = courseInfo[fieldName];

                        if (!isEmpty(fieldVal)) {
                            $el.remove();
                        }
                    });

                    $savedCourse.find('.js-course-remove').attr({
                        'data-gtm-event': 'Remove from saved',
                        'data-gtm-value': data.link,
                    });

                    $savedCourse.find('.js-course-compare').attr({
                        'data-gtm-event': 'Compare',
                        'data-gtm-value': data.link,
                    });

                    $savedCoursesContainer.append($savedCourse);
                });

                $findCta.hide();
                $findDownload.show();
                activateCourses(false, true);
            } else {
                $('.course-search-results__loading').hide();
                $savedCourseLoading.hide();
                $savedCoursesIcon.show();
                $savedCoursesNoResult.show();
                $findCta.show();
                $findDownload.hide();
            }
        } else {
            $savedCourseLoading.hide();
            $savedCoursesIcon.show();
            $savedCoursesNoResult.show();
            $findCta.show();
            $findDownload.hide();
        }
    }

    function updateCoursesCount(courseCount) {
        if (courseCount > 1) {
            $savedCourseLoading.hide();
            $savedCoursesNoResult.hide();
            $savedCoursesIcon.hide();
            $savedCoursesTitle.text('Saved courses');
            $findCta.hide();
            $savedCoursesCounter.text('Showing ' + courseCount + ' saved courses');
            $findDownload.show();
        } else if (courseCount === 1) {
            $savedCourseLoading.hide();
            $savedCoursesNoResult.hide();
            $savedCoursesIcon.hide();
            $savedCoursesTitle.text('Saved courses');
            $findCta.hide();
            $savedCoursesCounter.text('Showing 1 saved course');
            $findDownload.show();
        } else {
            $savedCoursesCounter.hide();
            $savedCourseLoading.hide();
            $savedCoursesNoResult.show();
            $savedCoursesIcon.show();
            $savedCoursesTitle.text('Your saved courses list is empty!');
            $findCta.show();
            $findDownload.hide();
        }
    }

    function activateCourses(removeCompared, removeSaved) {
        var comparedCourses = {},
            savedCourses = {},
            $coursePanels = $('[data-course-id][data-course-info]');

        if (typeof localStorage.comparedCourses !== 'undefined') {
            comparedCourses = JSON.parse(localStorage.getItem('comparedCourses'));
        }

        if (typeof localStorage.savedCourses !== 'undefined') {
            savedCourses = JSON.parse(localStorage.getItem('savedCourses'));
        }

        if (removeSaved) {
            updateCoursesCount($coursePanels.length);
        }

        $coursePanels.each(function () {
            var $coursePanel = $(this),
                $courseCompareButton = $coursePanel.find('.js-course-compare'),
                $courseSaveButton = $coursePanel.find('.js-course-remove'),
                courseId = decodeURIComponent($coursePanel.attr('data-course-id')),
                courseInfo = $coursePanel.attr('data-course-info'),
                courseInfoInternational = $coursePanel.attr(
                    'data-course-info-international'
                );

            if (comparedCourses.hasOwnProperty(courseId)) {
                $courseCompareButton.addClass('active').attr('aria-pressed', 'true');
            } else {
                $courseCompareButton
                    .removeClass('active')
                    .attr('aria-pressed', 'false');
            }

            $courseCompareButton.on('click', function () {
                if ($courseCompareButton.hasClass('active')) {
                    $courseCompareButton
                        .removeClass('active')
                        .attr('aria-pressed', 'false');
                    removeCourse('comparedCourses', courseId);
                } else {
                    $courseCompareButton.addClass('active').attr('aria-pressed', 'true');
                    addCourse(
                        'comparedCourses',
                        courseId,
                        courseInfo,
                        courseInfoInternational
                    );
                }
            });

            if (savedCourses.hasOwnProperty(courseId)) {
                if (removeSaved) {
                    $courseSaveButton
                        .addClass('active')
                        .find('span')
                        .text('Remove');
                } else {
                    $courseSaveButton
                        .addClass('active')
                        .find('span')
                        .text('Saved');
                }
            } else {
                $courseSaveButton
                    .removeClass('active')
                    .find('span')
                    .text('Save');
            }

            $courseSaveButton.on('click', function () {
                if ($courseSaveButton.hasClass('active')) {
                    removeCourse('savedCourses', courseId);

                    if (removeSaved) {
                        $coursePanel.remove();
                        updateCoursesCount($('[data-course-id][data-course-info]').length);
                    } else {
                        $courseSaveButton
                            .removeClass('active')
                            .find('span')
                            .text('Save');
                    }
                } else {
                    $courseSaveButton
                        .addClass('active')
                        .find('span')
                        .text('Saved');
                    addCourse('savedCourses', courseId, courseInfo);
                }
            });
        });

        // If accordions haven't been initialised yet, add click listener
        var $pDescTarget = $(
            '.panel-description:not(.panel-description--template) .panel-description__toggle'
        );
        if (!$pDescTarget.hasClass('initialised')) {
            $pDescTarget.click(function () {
                var $accordionToggle = $(this).closest('.panel-description__title'),
                    $accordionText = $accordionToggle.siblings(
                        '.panel-description__list'
                    );

                if ($accordionToggle.hasClass('active')) {
                    $accordionToggle.removeClass('active');
                    $accordionText.slideUp(300, function () {
                        $accordionText.removeClass('active').removeAttr('style');
                    });
                } else {
                    $accordionToggle.addClass('active');
                    $accordionText.slideDown(300, function () {
                        $accordionText.addClass('active').removeAttr('style');
                    });
                }

                return false;
            });

            // Prevent accordion from being initialised from other functions such as course search results js
            $pDescTarget.addClass('initialised');

            // Prevent focus on click
            $pDescTarget.on('mousedown click', function (e) {
                e.preventDefault();
                $(e.target).blur();
            });
        }
    }

    function addCourse(
        localStorageName,
        courseId,
        courseInfo,
        courseInfoInternational
    ) {
        var localStorageItem = {};
        var isInternationalSelected =
            localStorage.getItem('audience') === 'international';

        if (typeof localStorage[localStorageName] !== 'undefined') {
            localStorageItem = JSON.parse(localStorage.getItem(localStorageName));
        }

        localStorageItem[courseId] =
            isInternationalSelected &&
                courseInfoInternational &&
                localStorageName === 'comparedCourses'
                ? courseInfoInternational
                : courseInfo;
        localStorage.setItem(localStorageName, JSON.stringify(localStorageItem));

        updateCompareCounter();
        updateSavedCounter();
    }

    function removeCourse(localStorageName, courseId) {
        var localStorageItem = {};

        if (typeof localStorage[localStorageName] !== 'undefined') {
            localStorageItem = JSON.parse(localStorage.getItem(localStorageName));
        }

        if (localStorageItem.hasOwnProperty(courseId)) {
            delete localStorageItem[courseId];
        }

        localStorage.setItem(localStorageName, JSON.stringify(localStorageItem));

        updateCompareCounter();
        updateSavedCounter();
    }

    function updateCompareCounter() {
        if ($('.js-sticky-widget-compare').length) {
            if (typeof localStorage.comparedCourses !== 'undefined') {
                $('.js-sticky-widget-compare').text(
                    Object.keys(JSON.parse(localStorage.getItem('comparedCourses')))
                        .length
                );
            }
        }
    }

    function updateSavedCounter() {
        if ($('.js-sticky-widget-saved').length) {
            if (typeof localStorage.savedCourses !== 'undefined') {
                var savedCourseKeys = Object.keys(
                    JSON.parse(localStorage.getItem('savedCourses'))
                );
                //var endpoint = $findDownload.attr('href');
                var endpoint = $findDownload.data('href');
                $findDownload.attr(
                    'href',
                    endpoint + 'cl_id=' + savedCourseKeys.join('&cl_id=')
                );
                $('.js-sticky-widget-saved').text(savedCourseKeys.length);
            }
        }
    }
})(jQuery);
